import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { Observable, catchError, throwError } from 'rxjs';

import { ErrorService } from '../../shared/services/error.service';
import { LoggingService } from '../../shared/services/logging.service';
import { NotificationService } from '../../shared/services/notification.service';
import { SILENT_ERROR } from 'src/app/core/interceptors/silent-error.context';

@Injectable()
export class GlobalErrorHandlerInterceptor implements HttpInterceptor {
  private errorService = inject(ErrorService);
  private logger = inject(LoggingService);
  private notifier = inject(NotificationService);

  
  intercept<T>(request: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<T>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('HTTP Error:', error.error);

        const errorMessage = this.errorService.getClientErrorMessage(error);

        // Always log — useful for debugging regardless of visibility
        this.logger.logError(errorMessage);

        // Only surface a toast if this request hasn't opted out
        const isSilent = request.context.get(SILENT_ERROR);
        if (!isSilent) {
          this.notifier.showError(errorMessage);
        }

        return throwError(() => error);
      }),
    );
  }
}
